import { render, staticRenderFns } from "./MovingSlime.vue?vue&type=template&id=df8389f6&scoped=true"
import script from "./MovingSlime.vue?vue&type=script&lang=js"
export * from "./MovingSlime.vue?vue&type=script&lang=js"
import style0 from "./MovingSlime.vue?vue&type=style&index=0&id=df8389f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8389f6",
  null
  
)

export default component.exports